angular.module('rjmNg.constants')
.constant('filterConstants',

  MODIFICATION_ACTIONS: Object.freeze
    CREATE: 'CREATE'
    UPDATE: 'UPDATE'
    DELETE: 'DELETE'
    CLONE: 'CLONE'
    SHOWLIST: 'SHOWLIST'

)
